/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IEstimationUserChosenFilters } from '../estimation/EstimationUserChosenFilters';

export interface IEstimationSuburbanRequest {
  /** Адрес **/
  address: string;
  /** Категория оценки: участок либо дом **/
  category: ECategory;
  /** Площадь участка в сотках **/
  landArea: number;
  /** Площадь дома в квадратных метрах **/
  houseArea?: TEstimationSuburbanRequest_HouseArea;
  /** Выбранные пользователем фильтры **/
  filters?: TEstimationSuburbanRequest_Filters;
  /** Id оценки пользователя **/
  estimationId?: TEstimationSuburbanRequest_EstimationId;
  /** Координата по широте **/
  lat?: TEstimationSuburbanRequest_Lat;
  /** Координата по долготе **/
  lng?: TEstimationSuburbanRequest_Lng;
}

export enum ECategory {
  /** Загородный участок **/
  'LandSale' = 'landSale',
  /** Загородный дом **/
  'HouseSale' = 'houseSale',
}
export type TEstimationSuburbanRequest_HouseArea = null | TEstimationSuburbanRequest_HouseArea_1;

export type TEstimationSuburbanRequest_HouseArea_1 = string | number;

export type TEstimationSuburbanRequest_Filters = null | TEstimationSuburbanRequest_Filters_1;

export type TEstimationSuburbanRequest_Filters_1 = IEstimationUserChosenFilters[];

export type TEstimationSuburbanRequest_EstimationId = null | number;

export type TEstimationSuburbanRequest_Lat = null | number;

export type TEstimationSuburbanRequest_Lng = null | number;
